import { render } from "./EsquemasView.vue?vue&type=template&id=fe0423fa&scoped=true"
import script from "./EsquemasView.vue?vue&type=script&lang=js"
export * from "./EsquemasView.vue?vue&type=script&lang=js"

import "./EsquemasView.vue?vue&type=style&index=0&id=fe0423fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0423fa"]])

export default __exports__